export const modernTeal = {
  id: 'modern-teal',
  name: 'Modern Teal',
  isDark: false,
  variables: {
    '--font-family-primary': '"Inter", sans-serif',
    '--font-family-secondary': '"Roboto", sans-serif',
    '--color-primary': '#0F766E',      // Dark Teal
    '--color-secondary': '#0D9488',    // Medium Teal
    '--color-accent': '#14B8A6',       // Bright Teal
    '--color-bg-page': '#FFFFFF',      // White Paper
    '--color-text-main': '#1F2937',    // Near Black
    '--color-text-light': '#4B5563',   // Muted Charcoal
    '--color-border': '#E5E7EB',       // Very light grey
    '--spacing-multiplier': '0.9',      // Tighter design spacing by default
    '--heading-text-transform': 'uppercase',
    '--heading-letter-spacing': '0.05em',
    '--bullet-style': 'square',
  }
};
